module.exports = __webpack_public_path__ + "static/media/sound_button.fcd267ad.mp3";